import { Command, LabelCommand } from "@tylertech/commands-module";
import { Utilities } from "@tylertech/shared-module";
import { CachedRepositoryService, ToastService } from "@tylertech/core-module";
import { ClassMetadata, Tuple } from "@tylertech/tyler-api-types";
import { Component, Inject, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MetadataService } from "../../services";

export interface MetadataCreateEntityDialogData
{
    type: string,
    parameter: any,
    filter: string;
}

@Component({
    selector: "metadata-create-entity-dialog-component",
    templateUrl: "./metadataCreateEntity.dialog.tmpl.html",
    standalone: false
})
export class MetadataCreateEntityDialogComponent
{
    readonly commands: ReadonlyArray<Command>;

    metadata: ClassMetadata;

    entity: any;

    type: string;

    loading: boolean = true;

    saving: boolean = false;

    @ViewChild("form") form: NgForm;

    constructor(
        private readonly dialogRef: MatDialogRef<MetadataCreateEntityDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private dialogData: MetadataCreateEntityDialogData,
        private $repositoryService: CachedRepositoryService,
        private $toastService: ToastService,
        private $metadataService: MetadataService
    )
    {
        this.dialogRef.disableClose = true;
        const self = this;
        this.type = this.dialogData.type;

        this.commands = [
            new LabelCommand({
                label: "Cancel",
                action: () => self.cancel(),
            }),
            new LabelCommand({
                type: "raised",
                label: "Create",
                action: () => self.save(),
                getEnabled: () => !this.saving
            }),
        ];

        const t: Tuple<string, string> = {
            Item1: this.type,
            Item2: this.dialogData.parameter,
        };

        this.$repositoryService.GetNew(t, this.dialogData.filter)
            .then(result =>
            {
                self.entity = result;
                self.$repositoryService.GetMetadata(t)
                    .then(data =>
                    {
                        self.metadata = data;
                        self.loading = false;
                    });
            });
    }

    save(): void
    {
        const self = this;
        if (!this.form.invalid)
        {
            this.saving = true;
            const t: Tuple<string, string> = {
                Item1: this.type,
                Item2: Utilities.stringify(this.entity),
            };
            this.$repositoryService
                .Save(t)
                .then(onSuccess, err => this.onSaveFailed(err))
                .finally(() => (this.saving = false));
        }
        else
        {
            this.$metadataService.touchForm(this.form.controls);
        }
        function onSuccess(entity: any): void
        {
            self.entity = entity;
            self.dialogRef.close(self.entity);
        }
    }

    onSaveFailed(err): void
    {
        console.log(err);
        const msg = Utilities.getVerificationMesssage(err) || Utilities.getMessage(err, "Create failed.");
        this.$toastService.showToast(msg);
    }

    cancel(): void
    {
        this.dialogRef.close();
    }
}
